import {Breadcrumbs} from "./components/Breadcrumbs";
import React from "react";
import {BrowserRouter} from "react-router-dom";
import {InitOptions} from "../common/models/common.models";
import {createRoot} from "react-dom/client";
import { BreadcrumbsEvents } from '../common/events/breadcrumbs.events';

interface BreadcrumbsModuleOptions extends InitOptions {
    breadcrumbs?: any;
    baseUrl?: string;
    mediaServiceUrl?: string;
}

function init(options: BreadcrumbsModuleOptions) {
    const breadcrumbs = document.getElementsByClassName('ti-breadcrumbs');
    if (breadcrumbs && breadcrumbs.length) {
        const element = breadcrumbs[0] as HTMLElement;
        const isInitialized = element.getAttribute('isInitialized') === 'true';
        const breadcrumbsProps = {
            ...element.dataset,
            ...options.breadcrumbs,
            baseUrl: options.baseUrl,
            mediaServiceUrl: options.mediaServiceUrl,
        };
        if (!isInitialized) {
            element.setAttribute('isInitialized', 'true');
            const root = createRoot(element!);
            root.render(<BrowserRouter><Breadcrumbs {...breadcrumbsProps} /></BrowserRouter>);
        }
    }
}

export default {
    _options: null,
    _subscribed: false,
    init: function (options) {
        if (!this._subscribed) {
            window.addEventListener(BreadcrumbsEvents.initialize, e =>
                this.init((e as CustomEvent<BreadcrumbsModuleOptions>).detail)
            );
        }
        this._options = { ...this._options, ...options };
        init(this._options);
    },
} as {
    _options: BreadcrumbsModuleOptions | null;
    _subscribed: boolean;
    init: (options: BreadcrumbsModuleOptions) => void;
};
